
<template>

  <div class="item-unit-modal">
    <form action="" @submit.prevent="submitPrepaymentRequestData">
      <div class="card-body">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-label">{{ $t('general.promised_payment_date') }}</label><span class="text-danger"> *</span>
            <base-date-picker
              v-model="formData.promised_payment_date"
              :calendar-button="true"
              :disabled-dates = "{
                to: new Date(Date.now())
              }"
              calendar-button-icon="calendar"
              @change="$v.formData.promised_payment_date.$touch()"
            />
            <div v-if="$v.formData.promised_payment_date.$error">
              <span v-if="!$v.formData.promised_payment_date.required" class="text-danger">{{ $t('validation.required') }}</span>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <base-button
            :outline="true"
            class="mr-3"
            color="theme"
            type="button"
            @click="closeBulkProcessModal"
          >
            {{ $t('general.cancel') }}
          </base-button>
          <base-button
            :loading="isLoading"
            icon="save"
            color="theme"
            type="submit"
            class="collapse-button"
          >
            {{ $t('prepayments.save_prepayment') }}
          </base-button>
        </div>
      </div>
    </form>
  </div>

</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import MultiSelect from 'vue-multiselect'
import {validationMixin} from 'vuelidate'
import moment from 'moment'

const {required} = require('vuelidate/lib/validators')

export default {
  components: {MultiSelect},
  mixins: [validationMixin],
  data () {
    return {
      formData: {
        promised_payment_date: null
      },
      isLoading: false

    }
  },
  validations () {
    return {
      formData: {
        promised_payment_date: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters('invoice', [
      'selectedInvoices',
      'invoices'
    ]),
    ...mapGetters('modal', [
      'modalData'
    ])
  },
  mounted () {
  this.formData.invoice_ids = this.selectedInvoices

  const validInvoice = this.invoices.find(inv => inv.pre_payment_request && inv.pre_payment_request.invoice)

  if (validInvoice) {
    let data = {
      company_id: localStorage.getItem('selectedCompany'),
      guest_company_id: validInvoice.pre_payment_request.invoice.company_id
    }

    this.getImpact(data).then((response) => {
      let today = new Date()
      this.formData.promised_payment_date = moment(today).add(response.data.tenor, 'days').toString()
    })

  } else {
    console.error('No valid invoice found with pre_payment_request and invoice data.')
  }
},

  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData',
      'setIsSearching'
    ]),
    ...mapActions('companyImpactOthers', [
      'getImpact'
    ]),
    ...mapActions('invoice', [
      'bulkApproveRequestedInvoicesWithData'
    ]),

    async submitPrepaymentRequestData () {
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }
      let data = {
        ...this.formData
      }
      console.log(this.$v, data)
      // this.isLoading = true
      this.closeModal()

      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$tc('invoices.supplier_requested_invoices'),
        icon: '/assets/icon/paper-plane-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (value) => {
        if (value) {
          this.setIsSearching()
          let res = await this.bulkApproveRequestedInvoicesWithData(data)
          this.setIsSearching()
          if (res.data.success === true) {
            location.reload()
            this.filtersApplied = false
            this.resetSelectedInvoices()
            window.toastr['success'](this.$t('prepayments.prepayment_request_send_message'))
          } else if (res.data.success === false) {
            window.toastr['error'](res.data.error)
          }
        }
      })
    },

    resetFormData () {
      this.formData = {
        promised_payment_date: null
      }
      this.$v.formData.$reset()
    },
    closeBulkProcessModal () {
      // this.resetModalData()
      // this.resetFormData()
      // this.closeModal()
    }
  }
}
</script>
<style scoped>
  .table-component {
    min-height: 0px;
  }
</style>
